import { groq } from "next-sanity"

import { AppSettings } from "@/settings"

export const queryConfiguration = {
  async configuration(parent, args, context, info) {
    const { lang = AppSettings.defaultLocale(), cdn = true } = args

    const config = AppSettings.sanityConfigByLang(lang)
    const client = context.sanityClient
    client.config({ ...config, useCdn: cdn })

    let configuration
    configuration = await client.fetch(
      groq`*[_type=="configuration" && !(_id in path("drafts.**"))][0] {
        company,
        country,
        lang,
        title
      }`,
    )

    configuration = await client.fetch(
      groq`*[_type=="configuration" && !(_id in path("drafts.**"))][0] {
        company,
        country,
        lang,
        title
      }`,
    )

    configuration = configuration || {}

    return configuration
  },
}
